import { render, staticRenderFns } from "./FfgTest.vue?vue&type=template&id=1ebc54c6&scoped=true&"
import script from "./FfgTest.vue?vue&type=script&lang=js&"
export * from "./FfgTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc54c6",
  null
  
)

export default component.exports